/**
 * Kleine Ergaenzungen zum API-Client (api.ts): PATCH/PUT, Query-Strings,
 * tolerantes Lesen von Listen und Datei-URLs (PDF/ZPL/CSV).
 */
import { api } from '../api';
import { mockDateiUrl, mockModus } from './mock';
import type { Seite } from './typen';

export const patch = <T,>(pfad: string, daten: unknown) => api<T>(pfad, { method: 'PATCH', body: JSON.stringify(daten) });
export const put = <T,>(pfad: string, daten: unknown) => api<T>(pfad, { method: 'PUT', body: JSON.stringify(daten) });

/** `{a: 1, b: undefined}` → `?a=1`; leere Werte fallen weg. */
export function qs(p: object): string {
  const u = new URLSearchParams();
  for (const [k, v] of Object.entries(p)) if (v !== undefined && v !== null && v !== '') u.set(k, String(v));
  const s = u.toString();
  return s ? `?${s}` : '';
}

type ListenAntwort<T> = T[] | Seite<T> | { eintraege: T[]; total: number };

/** Liste aus nacktem Array, `{ eintraege, gesamt }` (Kern, Belege) oder `{ eintraege, total }` (Protokoll-Listen der Integrationen). */
export function alsSeite<T>(r: ListenAntwort<T>): Seite<T> {
  if (Array.isArray(r)) return { eintraege: r, gesamt: r.length };
  if ('gesamt' in r) return r;
  return { eintraege: r.eintraege, gesamt: r.total };
}

export async function liste<T>(pfad: string): Promise<Seite<T>> {
  return alsSeite(await api<ListenAntwort<T>>(pfad));
}

/**
 * URL einer Datei der API (z. B. `/labels/<id>.pdf`). Im Mock-Modus erzeugt
 * die Mock-Schicht ein Blob (kleines PDF bzw. Text), sonst ist es der echte
 * Pfad, den der Browser mit Session-Cookie oeffnet.
 */
export async function dateiUrl(pfad: string): Promise<string> {
  if (mockModus() !== 'aus') {
    const blob = await mockDateiUrl(pfad);
    if (blob) return blob;
  }
  return `/api${pfad}`;
}
